module.exports = __webpack_public_path__ + "img/antologhion-1786-pagina-de-titlu-big.e2119083.jpg";